import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ServiceChargeInvoiceSettingsModel } from "services/api/cplapi/CPLAPI";
import { FileParameter } from "services/api/cplauthapi/CPLAuthAPI";
import { IServiceChargeInvoiceSettingsService } from "services/ServiceChargeInvoiceSettingsService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

type ServiceChargeInvoiceSettingsType = {
  IsLoading: boolean;
  Logos: ServiceChargeInvoiceSettingsModel;
};

const initialState: ServiceChargeInvoiceSettingsType = {
  IsLoading: false,
  Logos: new ServiceChargeInvoiceSettingsModel(),
};

export const ServiceChargeInvoiceSettingsSlice = createSlice({
  name: "serviceChargeInvoiceSettings",
  initialState,
  reducers: {
    setLogos: (state, action) => {
      state.Logos = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReportLogos.fulfilled, (state, action) => {
        state.Logos = action.payload;
        state.IsLoading = false;
      })
      .addCase(getReportLogos.pending, (state) => {
        state.IsLoading = true;
      })
      .addCase(getReportLogos.rejected, (state) => {
        state.IsLoading = false;
      });
  },
});

export const getReportLogos = createAsyncThunk("serviceChargeInvoiceSettings/getReportLogos", async () => {
  const serviceChargeInvoiceSettingsService = container.get<IServiceChargeInvoiceSettingsService>(
    SERVICE_TYPES.ServiceChargeInvoiceSettingsService
  );
  return await serviceChargeInvoiceSettingsService.getLogoURLs();
});

export const uploadHeaderLogo = createAsyncThunk(
  "serviceChargeInvoiceSettings/deleteHeaderLogo",
  async ({ headerImage }: { headerImage: FileParameter }) => {
    const serviceChargeInvoiceSettingsService = container.get<IServiceChargeInvoiceSettingsService>(
      SERVICE_TYPES.ServiceChargeInvoiceSettingsService
    );
    return await serviceChargeInvoiceSettingsService.uploadHeaderLogo(headerImage);
  }
);

export const uploadFooterLogo = createAsyncThunk(
  "serviceChargeInvoiceSettings/deleteFooterLogo",
  async ({ footerImage }: { footerImage: FileParameter }) => {
    const serviceChargeInvoiceSettingsService = container.get<IServiceChargeInvoiceSettingsService>(
      SERVICE_TYPES.ServiceChargeInvoiceSettingsService
    );
    return await serviceChargeInvoiceSettingsService.uploadFooterLogo(footerImage);
  }
);

export const deleteHeaderLogo = createAsyncThunk("serviceChargeInvoiceSettings/deleteHeaderLogo", async () => {
  const serviceChargeInvoiceSettingsService = container.get<IServiceChargeInvoiceSettingsService>(
    SERVICE_TYPES.ServiceChargeInvoiceSettingsService
  );
  return await serviceChargeInvoiceSettingsService.deleteHeaderLogo();
});

export const deleteFooterLogo = createAsyncThunk("serviceChargeInvoiceSettings/deleteFooterLogo", async () => {
  const serviceChargeInvoiceSettingsService = container.get<IServiceChargeInvoiceSettingsService>(
    SERVICE_TYPES.ServiceChargeInvoiceSettingsService
  );
  return await serviceChargeInvoiceSettingsService.deleteFooterLogo();
});

export const selectLogosLoading = (state: RootState) => {
  return state.serviceChargeInvoiceSettings.IsLoading;
};
export const selectLogos = (state: RootState) => {
  return state.serviceChargeInvoiceSettings.Logos;
};

export default ServiceChargeInvoiceSettingsSlice.reducer;
